import React from 'react';
import { OfferBanner } from '../components/OfferBanner';
import { HeroSection } from '../components/HeroSection';
import { EmotionalConnection } from '../components/EmotionalConnection';
import { AvatarPains } from '../components/AvatarPains';
import { SolutionBenefits } from '../components/SolutionBenefits';
import { ProductOffer } from '../components/ProductOffer';
import { Bonuses } from '../components/Bonuses';
import { BreedGallery } from '../components/BreedGallery';
import { EbookPreview } from '../components/EbookPreview';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen font-body text-deep-brown selection:bg-soft-rose selection:text-white" data-id="element-417">
      <OfferBanner data-id="element-418" />
      <main data-id="element-419">
        <HeroSection data-id="element-420" />
        <EmotionalConnection data-id="element-421" />
        <AvatarPains data-id="element-422" />
        <SolutionBenefits data-id="element-423" />
        <BreedGallery data-id="element-424" />
        <EbookPreview data-id="element-425" />
        <ProductOffer data-id="element-426" />
        <Bonuses data-id="element-427" />
        <Testimonials data-id="element-428" />
        <FAQ data-id="element-429" />
      </main>
      <Footer data-id="element-430" />
      <FloatingCTA data-id="element-431" />
      <PurchasePopup data-id="element-432" />
    </div>;
}